export const SUPPORT_EMAIL = 'support@ystudiox.com';
